<template>
    <div class="block-search">
        <form id="form-search" @submit.prevent="onSubmit">
            <i class="icon-close"></i>
            <input id="search-field" type="text" value="" placeholder="Rechercher dans le site..." v-model="search" />
            <input type="submit" value="OK" />
        </form>
        <p v-if="errorNoResult" class="noresult">
            <slot name="error-no-result"></slot>
        </p>
    </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import SearchResults from "../../popups/SearchResults";

export default {
    props: ['type'],
    data() {
        return {
            search: null,
            hasError: false,
            errorNoResult: false
        }
    },
    watch: {
        search(after, before) {
            this.resetErrors();
        }
    },
    mounted() {
        $('.block-search .icon-close, .popup-search-results .icon-close').click(() => {
            $('.popup-search-results').slideUp(300);
            $('.block-search').removeClass('active');
            $('body').removeClass('noscroll');
            $('header .header-right').removeClass('hide');
            document.getElementById("form-search").reset();
            this.resetErrors();
        })
    },
    methods: {
        resetErrors() {
            this.errorNoResult = this.hasError = false;
        },
        onSubmit() {
            if(!this.search || this.search.length < 3) {
                $('.popup-search-results').slideUp(300);
                this.errorNoResult = this.hasError = true;
            }

            if(this.hasError)
                return;


            // Update URL for tracking
            if (window.history.replaceState) {
                let urlParams = new URLSearchParams(window.location.search);
                urlParams.set('search', encodeURIComponent(this.search));

                let url = new URL(document.location.toString());
                url.search = urlParams;

                window.history.replaceState({ },'', url.toString());
            }

            let url = window.drupalSettings.path.baseUrl + 'rest/content';
            if(this.type === 'pro')
                url = window.drupalSettings.path.baseUrl + 'rest/content-pro';

            axios({
                method: 'get',
                url: url,
                params: {
                    search: this.search
                }
            }).then((response) => {
                if(response.data.length === 0) {
                    $('.popup-search-results').slideUp(300);
                    this.errorNoResult = true;
                    return;
                }

                this.$eventBus.$emit('showSearchResults');
                this.$eventBus.$emit('fillSearchResults', response.data);
            }).catch((error) => {

            });
        }
    }
}
</script>
